export default function Checkbox(props:{value:boolean, onChange: (value: boolean)=>void, onBlur?: ()=>void}){
    return <div 
            role="checkbox" 
            type="checkbox" 
            tabIndex={0} 
            aria-checked={props.value}
            className={"checkbox result-item__checkbox mt-2 mr-4 cursor-pointer" + (props.value ? " checkbox--checked" : "")}
            onClick={(event)=>{props.onChange(!props.value)}} 
            onKeyUp={ (event) => {
                if ((event.code != " ")  && (event.code != "Enter")) { return } 
                props.onChange(!props.value);
            }}
            >
            <input 
                inert
                aria-hidden
                className="checkbox__input" 
                onChange={(event)=>{
                    event.stopPropagation();
                    props.onChange(event.target.checked);
                }} 
                checked={props.value} 
                onBlur={props.onBlur}
            />
    </div>
}